import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import RequestHeader from './components/RequestHeader';
import DocumentContent from './components/DocumentContent';
import RevisionHistory from './components/RevisionHistory';
import RevisionModal from './components/RevisionModal';

const RequestDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);
  const [isSubmittingRevision, setIsSubmittingRevision] = useState(false);

  // Mock data for the request
  const mockRequest = {
    id: id || 'REQ-2024-001',
    documentType: 'اظهارنامه قضایی',
    claimantName: 'علی احمدی',
    respondentName: 'شرکت پارس صنعت',
    subject:
      'مطالبه مبلغ ۵۰ میلیون تومان بابت عدم پرداخت حق‌الزحمه خدمات مشاوره‌ای ارائه شده طبق قرارداد منعقده',
    description: `در تاریخ ۱۵ فروردین ۱۴۰۲ قراردادی جهت ارائه خدمات مشاوره‌ای در زمینه بهینه‌سازی فرآیندهای تولید با شرکت پارس صنعت منعقد گردید. طبق شرایط قرارداد، کلیه خدمات مشاوره‌ای در مدت ۶ ماه ارائه و تحویل گردید اما علی‌رغم گذشت بیش از ۸ ماه از تاریخ تحویل، شرکت مذکور از پرداخت حق‌الزحمه متعهده خودداری نموده است.

خدمات ارائه شده شامل:
- تحلیل و بررسی فرآیندهای موجود
- طراحی و پیاده‌سازی سیستم بهینه‌سازی
- آموزش پرسنل و تحویل مستندات فنی
- پشتیبانی ۳ ماهه پس از تحویل پروژه

با توجه به اینکه تمامی تعهدات قراردادی از سوی اینجانب انجام شده و شرکت مذکور نیز از خدمات ارائه شده بهره‌مند گردیده، لذا مطالبه مبلغ ۵۰ میلیون تومان به عنوان حق‌الزحمه خدمات ارائه شده، مطابق با شرایط قرارداد و قوانین جاری کشور می‌باشد.`,
    status: 'completed',
    createdAt: '2024-10-15T09:30:00Z',
    updatedAt: '2024-11-01T14:20:00Z',
    aiContent: `بسمه تعالی

دادنامه اظهارنامه قضایی

به ریاست محترم دادگاه عمومی حقوقی تهران

اظهارنامه قضایی در خصوص مطالبه وجه

خواهان: آقای علی احمدی
نشانی: تهران، خیابان ولیعصر، پلاک ۱۲۳۴
کد ملی: ۰۱۲۳۴۵۶۷۸۹
تلفن: ۰۹۱۲۱۲۳۴۵۶۷

خوانده: شرکت پارس صنعت
نشانی: تهران، خیابان کریمخان زند، پلاک ۵۶۷۸
شناسه ملی: ۱۰۱۰۱۰۱۰۱۰
تلفن: ۰۲۱۸۸۷۷۶۶۵۵

موضوع: مطالبه مبلغ پنجاه میلیون (۵۰،۰۰۰،۰۰۰) تومان

شرح دعوا:

احتراماً، اینجانب علی احمدی در تاریخ ۱۵ فروردین ۱۴۰۲ قراردادی را جهت ارائه خدمات مشاوره‌ای در زمینه بهینه‌سازی فرآیندهای تولید با شرکت پارس صنعت (خوانده) منعقد نمودم.

مفاد قرارداد:
۱. ارائه خدمات مشاوره‌ای تخصصی در زمینه بهینه‌سازی فرآیندهای تولید
۲. مدت قرارداد: ۶ ماه از تاریخ امضا
۳. مبلغ قرارداد: ۵۰،۰۰۰،۰۰۰ تومان
۴. نحوه پرداخت: یک‌جا پس از تحویل نهایی پروژه

خدمات انجام شده:
- تحلیل کامل فرآیندهای موجود شرکت
- طراحی سیستم بهینه‌سازی مطابق با نیازهای شرکت
- پیاده‌سازی و راه‌اندازی سیستم جدید
- آموزش کامل پرسنل شرکت
- تحویل کلیه مستندات فنی و راهنماهای کاربری
- ارائه پشتیبانی ۳ ماهه پس از تحویل

اینجانب تمامی تعهدات قراردادی خود را در مهلت مقرر و با کیفیت مطلوب انجام داده و در تاریخ ۱۵ مهر ۱۴۰۲ پروژه را به صورت کامل تحویل نمودم. شرکت خوانده نیز رسید تحویل را امضا و مهر نموده است.

علی‌رغم گذشت بیش از ۸ ماه از تاریخ تحویل پروژه و استفاده شرکت خوانده از خدمات ارائه شده، وی از پرداخت مبلغ متعهده خودداری نموده و علی‌رغم مراجعات متعدد و ارسال اخطارهای کتبی، هیچگونه پاسخی ارائه ننموده است.

مستندات:
۱. اصل قرارداد منعقده
۲. رسید تحویل پروژه
۳. اخطارهای کتبی ارسالی
۴. مستندات انجام خدمات

مبنای قانونی:
- ماده ۲۱۹ قانون مدنی (لزوم وفای به عهد)
- ماده ۲۲۰ قانون مدنی (الزام به انجام تعهدات)
- ماده ۵۱۸ قانون مدنی (خسارت تأخیر)

درخواست:
با توجه به مراتب فوق، تقاضا دارم دستور فرمایید:
۱. خوانده محکوم به پرداخت مبلغ ۵۰،۰۰۰،۰۰۰ تومان به عنوان اصل طلب گردد
۲. خوانده محکوم به پرداخت خسارت تأخیر از تاریخ سررسید تا زمان پرداخت گردد
۳. خوانده محکوم به پرداخت کلیه هزینه‌های دادرسی و حق‌الوکاله وکیل گردد

امید است دادگاه محترم با بررسی مستندات ارائه شده، حکم به محکومیت خوانده صادر فرمایند.

با احترام
علی احمدی
تاریخ: ۱۵ آبان ۱۴۰۳

ضمائم:
- اصل قرارداد
- رسید تحویل
- اخطارهای کتبی
- مستندات فنی پروژه`,
  };

  const mockRevisions = [
    {
      id: 1,
      type: 'created',
      title: 'ایجاد درخواست',
      description: 'درخواست جدید برای تولید اظهارنامه قضایی ثبت شد',
      timestamp: '2024-10-15T09:30:00Z',
    },
    {
      id: 2,
      type: 'ai_generated',
      title: 'تولید محتوا توسط هوش مصنوعی',
      description: 'نسخه اولیه سند توسط هوش مصنوعی تولید شد',
      timestamp: '2024-10-15T11:45:00Z',
    },
    {
      id: 3,
      type: 'revision_requested',
      title: 'درخواست بازنگری',
      description: 'کاربر درخواست اصلاح بخش مبنای قانونی را ارسال کرد',
      timestamp: '2024-10-16T14:20:00Z',
      feedback:
        'لطفاً مواد قانونی بیشتری به بخش مبنای قانونی اضافه کنید و ارجاعات دقیق‌تری ارائه دهید.',
      aiResponse:
        'درخواست شما دریافت شد. مواد قانونی اضافی و ارجاعات دقیق‌تر به سند اضافه خواهد شد.',
    },
    {
      id: 4,
      type: 'updated',
      title: 'بروزرسانی محتوا',
      description: 'محتوای سند بر اساس بازخورد کاربر بروزرسانی شد',
      timestamp: '2024-10-17T10:15:00Z',
    },
    {
      id: 5,
      type: 'completed',
      title: 'تکمیل سند',
      description: 'سند نهایی آماده و قابل دانلود است',
      timestamp: '2024-11-01T14:20:00Z',
    },
  ];

  useEffect(() => {
    // Simulate API call
    const fetchRequest = async () => {
      setIsLoading(true);
      try {
        // Simulate network delay
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setRequest(mockRequest);
      } catch (error) {
        console.error('Error fetching request:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRequest();
  }, [id]);

  const handleDownload = async () => {
    if (!request?.aiContent) return;

    setIsDownloading(true);
    try {
      // Simulate download delay
      await new Promise((resolve) => setTimeout(resolve, 1500));

      // Create and download file
      const blob = new Blob([request.aiContent], {
        type: 'text/plain;charset=utf-8',
      });
      const url = window.URL?.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `اظهارنامه-قضایی-${request?.id}.txt`;
      document.body?.appendChild(link);
      link?.click();
      document.body?.removeChild(link);
      window.URL?.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleRevisionSubmit = async (revisionData) => {
    setIsSubmittingRevision(true);
    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Update request status
      setRequest((prev) => ({
        ...prev,
        status: 'revision_requested',
        updatedAt: new Date()?.toISOString(),
      }));

      setIsRevisionModalOpen(false);

      // Show success message (you can integrate with toast library)
      alert('درخواست بازنگری با موفقیت ارسال شد');
    } catch (error) {
      console.error('Revision submission error:', error);
      alert('خطا در ارسال درخواست بازنگری');
    } finally {
      setIsSubmittingRevision(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="flex flex-col items-center gap-4">
              <div className="animate-spin">
                <Icon name="Loader2" size={40} className="text-primary" />
              </div>
              <p className="text-lg text-muted-foreground">
                در حال بارگذاری جزئیات درخواست...
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!request) {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <Icon
                name="FileX"
                size={64}
                className="text-muted-foreground mx-auto mb-4"
              />
              <h2 className="text-xl font-semibold text-foreground mb-2">
                درخواست یافت نشد
              </h2>
              <p className="text-muted-foreground mb-6">
                درخواست مورد نظر شما یافت نشد یا ممکن است حذف شده باشد.
              </p>
              <Link to="/requests-management">
                <Button
                  variant="default"
                  iconName="ArrowRight"
                  iconPosition="right">
                  بازگشت به لیست درخواست‌ها
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
          <Link
            to="/dashboard-overview"
            className="hover:text-foreground transition-smooth">
            داشبورد
          </Link>
          <Icon name="ChevronLeft" size={16} />
          <Link
            to="/requests-list"
            className="hover:text-foreground transition-smooth">
            درخواست‌ها
          </Link>
          <Icon name="ChevronLeft" size={16} />
          <span className="text-foreground">جزئیات درخواست</span>
        </nav>

        <div className="space-y-6">
          {/* Request Header */}
          <RequestHeader
            request={request}
            onDownload={handleDownload}
            onRequestRevision={() => setIsRevisionModalOpen(true)}
            isDownloading={isDownloading}
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-6">
              <DocumentContent content={request?.aiContent} isLoading={false} />
            </div>

            {/* Sidebar */}
            <div className="space-y-6">
              <RevisionHistory revisions={mockRevisions} />

              {/* Quick Actions */}
              <div className="bg-card rounded-lg border border-border p-4 card-shadow">
                <h3 className="font-semibold text-foreground mb-4">
                  عملیات سریع
                </h3>
                <div className="space-y-3">
                  <Link to="/new-request-form" className="block">
                    <Button
                      variant="outline"
                      className="w-full justify-start"
                      iconName="Plus"
                      iconPosition="right">
                      ایجاد درخواست جدید
                    </Button>
                  </Link>

                  <Link to="/requests-management" className="block">
                    <Button
                      variant="ghost"
                      className="w-full justify-start"
                      iconName="List"
                      iconPosition="right">
                      مشاهده همه درخواست‌ها
                    </Button>
                  </Link>

                  <Button
                    variant="ghost"
                    className="w-full justify-start text-muted-foreground"
                    iconName="Share2"
                    iconPosition="right">
                    اشتراک‌گذاری درخواست
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Revision Modal */}
      <RevisionModal
        isOpen={isRevisionModalOpen}
        onClose={() => setIsRevisionModalOpen(false)}
        onSubmit={handleRevisionSubmit}
        isSubmitting={isSubmittingRevision}
      />
    </div>
  );
};

export default RequestDetails;
